class ProductControl {
    constructor() {
        this.cacheDom();
        this.bindEvents();
    }

    cacheDom() {
        this.currentActiveType = null;
        this.btnTrigger = document.querySelectorAll('.c-productSpec__btn');
        this.productImage = document.querySelectorAll('.c-annotation__product');
        this.productDetails = document.querySelectorAll('.c-productSpec__items');
    }

    bindEvents() {
        if (_.isNull(this.btnTrigger) === false) {
            Array.prototype.forEach.call(this.btnTrigger, (el, i) => {
                 el.addEventListener('click', (e) => {
                    e.preventDefault();
                    const btnType = el.getAttribute('data-type');
                    
                    this.removeActiveBtn();

                    if (_.isEqual(this.currentActiveType, btnType) === false) {
                        this.changeImageState(btnType);
                    }
                    
                    el.classList.add('c-productSpec__btn--active');
                 });

                this.triggerFirst(el, i);
            }, false);
        }
    }

    changeImageState(el) {
        this.currentActiveType = el;
        const element = document.querySelectorAll(`.${el}`);

        if (_.isNull(element) === false) {

            this.unSetImageState();

            Array.prototype.forEach.call(element, (item, i) => {
                if (item.classList.contains('c-annotation__product')) {
                   
                    item.classList.add('c-annotation__product--block');
                    setTimeout(() => {
                        item.classList.add('c-annotation__product--active');
                    }, 200);

                } else if (item.classList.contains('c-productSpec__items')) {
                    
                    item.classList.add('c-productSpec__items--block');
                    setTimeout(() => {
                        item.classList.add('c-productSpec__items--active');
                    }, 200);
                }
            });
        }
    }

    removeActiveBtn() {
        Array.prototype.forEach.call(this.btnTrigger, (el, i) => {
            el.classList.remove('c-productSpec__btn--active');
        });
    }

    unSetImageState() {
        if (_.isNull(this.productImage) === false) {
            Array.prototype.forEach.call(this.productImage, (el, i) => {
                el.classList.remove('c-annotation__product--active');
                el.classList.remove('c-annotation__product--block');
            });
        }

        if (_.isNull(this.productDetails) === false) {
            Array.prototype.forEach.call(this.productDetails, (el, i) => {
                el.classList.remove('c-productSpec__items--active');
                el.classList.remove('c-productSpec__items--block');
            });
        }
    }

    triggerFirst(el, i) {
        if (i === 0) {
            el.click();
        }
    }
}

module.exports = ProductControl;